import SideBar from "./SideBar";
import Main from "./Main.js";

const Body=()=>{
    return(
        <div>
            <Main/> 
        </div>
    );
}
export default Body;
